export const getHostname = (fallback) => {
  // window does not exists in nodejs, ignore
  try {
    let host = window.location.hostname ?? fallback ?? 'tipple.com.au'
    return host === 'localhost' || host.startsWith('192.') ? 'tipple.xyz' : host
  } catch (error) {
    return fallback ?? 'tipple.com.au'
  }
}
